// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchPermissions } from "../redux/slices/branch/permissionManagerSlice";
// import "../assets/css/dashboard.css";

// import {
//   FaWallet,
//   FaChartPie,
//   FaBook,
//   FaUniversity,
//   FaRupeeSign,
//   FaMoneyCheckAlt,
//   FaHandHoldingUsd,
//   FaUserFriends,
//   FaSearch,
//   FaFileInvoice,
//   FaUsers,
//   FaClipboardList,
// } from "react-icons/fa";

// import {
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   CartesianGrid,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
// } from "recharts";
// import axios from "axios";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// export default function BranchDashboard() {
//   const dispatch = useDispatch();
//   const { data: userPermissions = [], loading } = useSelector(
//     (state) => state.permissionManager,
//   );
//   const { profile } = useSelector((state) => state.userProfile);
//   const [collectionData, setCollectionData] = useState({});
//   const [pendingCollectionData, setPendingCollectionData] = useState({});

//   // Read userId from localStorage (fallback to 10 if not found)
//   const storedUserId = localStorage.getItem("userId");
//   const userId = storedUserId ? parseInt(storedUserId, 10) : 10;

//   // format
//   const formatINR = (v = 0) =>
//   `₹ ${Number(v).toLocaleString("en-IN")}`;

//   // profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   useEffect(() => {
//     if (userId) {
//       dispatch(fetchPermissions(userId));
//     }
//   }, [dispatch, userId]);

//     const fetchCollection = async () => {
//     try {
//       const result = await axios.get(
//         `https://payyug.in/api/dashboard-collection/api?superAdminId=${profile.superAdminId}&branchId=${profile.id}`,
//       );
//       // console.log("collection report", result);
//       setCollectionData(result.data.data);
//     } catch (error) {
//       console.log(error?.response?.data?.message || "fetch Collection error");
//     }
//   };

//   const fetchPendingCollection = async () => {
//     try {
//       const result = await axios.get(
//         `https://payyug.in/api/dashboard-list/?superAdminId${profile.superAdminId}&branchId=${profile.id}`,
//       );
//       // console.log("pending collection report", result.data);
//       setPendingCollectionData(result.data.data);
//     } catch (error) {
//       console.log(
//         error?.response?.data?.message || "fetch Pending Collection error",
//       );
//     }
//   };

//   useEffect(() => {
//     if (profile?.superAdminId && profile?.id) {
//       fetchCollection();
//       fetchPendingCollection();
//     }
//   }, [profile?.superAdminId, profile?.id]);

//   // Dummy KPIs (left column uses colored stripe blocks like the image)
//   const kpiData = [
//     {
//       label: "Wallet Balance",
//       value: "₹0",
//       color: "#2e8b57",
//       icon: <FaWallet />,
//     },
//     {
//       label: "Total Customers",
//       value: "00",
//       color: "#2aa9b8",
//       icon: <FaUserFriends />,
//     },
//     {
//       label: "Total Loans",
//       value: "₹0",
//       color: "#d9c39a",
//       icon: <FaMoneyCheckAlt />,
//     },
//     {
//       label: "Outstanding",
//       value: "₹0",
//       color: "#0f2740",
//       icon: <FaHandHoldingUsd />,
//     },
//   ];

//   const quickAccess = [
//     {
//       label: "Search Customer",
//       icon: <FaSearch />,
//       link: "/Customers/SearchCustomer",
//     },
//     {
//       label: "Loan Applications",
//       icon: <FaClipboardList />,
//       link: "/Loan/PersonalLoanForm",
//     },
//     {
//       label: "Customer Reports",
//       icon: <FaFileInvoice />,
//       link: "/CustomerReport",
//     },
//     {
//       label: "Loan Reports",
//       icon: <FaFileInvoice />,
//       link: "/Loan/LoanReport",
//     },
//     // { label: "User Management", icon: <FaUsers />, link: "/Users" },
//   ];

//   const overviewData = [
//     {
//       title: "Collection",
//       today: `${formatINR(collectionData.today) ?? 0}`,
//       weekly: `${formatINR(collectionData.weekly) ?? 0}`,
//       monthly: `${formatINR(collectionData.monthly) ?? 0}`,
//       yearly: `${formatINR(collectionData.yearly) ?? 0}`,
//       total: `${formatINR(collectionData.total) ?? 0}`,
//     },
//     {
//       title: "Pending Collection",
//       today: `${formatINR(pendingCollectionData.today) ?? 0}`,
//       weekly: `${formatINR(pendingCollectionData.weekly) ?? 0}`,
//       monthly: `${formatINR(pendingCollectionData.monthly) ?? 0}`,
//       yearly: `${formatINR(pendingCollectionData.yearly) ?? 0}`,
//       total: `${formatINR(pendingCollectionData.total) ?? 0}`,
//     },
//     {
//       title: "Created Loan",
//       today: "₹ 0",
//       weekly: "₹ 0",
//       monthly: "₹ 0",
//       yearly: "₹ 0",
//       total: "0",
//     },
//     {
//       title: "Opened Account",
//       today: "₹ 0",
//       weekly: "₹ 0",
//       monthly: "₹ 0",
//       yearly: "₹ 0",
//       total: "₹ 0",
//     },
//   ];

//   const financialData = [
//     { label: "Cashbook", value: "₹0", icon: <FaBook /> },
//     { label: "Bankbook", value: "₹0", icon: <FaUniversity /> },
//     { label: "Charges", value: "₹0", icon: <FaRupeeSign /> },
//     { label: "Reports", value: "₹0", icon: <FaChartPie /> },
//   ];

//   // Chart data
//   const lineData = [
//     { name: "Jan", collection: 0, pending: 0 },
//     { name: "Feb", collection: 0, pending: 0 },
//     { name: "Mar", collection: 0, pending: 0 },
//     { name: "Apr", collection: 0, pending: 0 },
//     { name: "May", collection: 0, pending: 0 },
//     { name: "Jun", collection: 0, pending: 0 },
//     { name: "Jul", collection: 0, pending: 0 },
//   ];
//   const pieData = [
//     { name: "Personal Loans", value: 0 },
//     { name: "Business Loans", value: 0 },
//     { name: "Home Loans", value: 0 },
//     { name: "Others", value: 0 },
//   ];
//   const pieColors = ["#2563eb", "#1d4ed8", "#60a5fa", "#93c5fd"];

//   // if (loading) return <p>Loading dashboard...</p>;
//   if (!collectionData || !pendingCollectionData) {
//   return <p>Loading dashboard data...</p>;
// }

//   return (
//     <div className="BranchDashboard-container cream-bg">
//       {/* Header (nav / title stripe like image) */}
//       {/* <header className="BranchDashboard-header cream-header">
//         <h1 className="BranchDashboard-title">Branch Dashboard</h1>
//         <div className="BranchDashboard-meta">
//           <p>User: <strong>Manager</strong></p>
//           <p>Date: {new Date().toLocaleDateString()}</p>
//         </div>
//       </header> */}

//       <div className="BranchDashboard-body">
//         {/* Left column (KPIs + Collection quick access) */}
//         <aside className="BranchDashboard-left">
//           <section className="section-card boxed-section">
//             <div className="section-card-title navy-title">KPIs</div>

//             <div className="kpi-list">
//               {kpiData.map((k, idx) => (
//                 <div className="kpi-row" key={idx}>
//                   <div
//                     className="kpi-stripe"
//                     style={{ backgroundColor: k.color }}
//                   >
//                     <div className="kpi-icon">{k.icon}</div>
//                   </div>
//                   <div className="kpi-content">
//                     <div className="kpi-label">{k.label}</div>
//                     <div className="kpi-value">{k.value}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </section>

//           <section className="section-card boxed-section mt-18">
//             <div className="section-card-title navy-title">
//               Collection &amp; Overview
//             </div>
//             <div className="quick-grid">
//               {quickAccess.map((q, i) => (
//                 <a className="quick-card outline-card" key={i} href={q.link}>
//                   <div className="quick-icon">{q.icon}</div>
//                   <div className="quick-label">{q.label}</div>
//                 </a>
//               ))}
//             </div>
//           </section>
//         </aside>

//         {/* Right column (Financial summary + overview tables + charts) */}
//         <main className="BranchDashboard-right">
//           <section className="section-card boxed-section">
//             <div className="section-card-title navy-title">
//               Financial Summary
//             </div>

//             <div className="financial-grid">
//               {financialData.map((f, i) => (
//                 <div className="financial-card small" key={i}>
//                   <div className="financial-icon">{f.icon}</div>
//                   <div className="financial-label">{f.label}</div>
//                   <div className="financial-value">{f.value}</div>
//                 </div>
//               ))}
//             </div>
//           </section>

//           <section className="section-card boxed-section mt-18">
//             <div className="section-card-title navy-title">
//               Collection &amp; Overview
//             </div>

//             <div className="overview-tables">
//               {overviewData.map((ov, i) => (
//                 <div className="overview-card" key={i}>
//                   <h3 className="overview-title">{ov.title}</h3>
//                   <table className="overview-table">
//                     <tbody>
//                       <tr>
//                         <td>Today</td>
//                         <td className="text-right">{ov.today}</td>
//                       </tr>
//                       <tr>
//                         <td>Weekly</td>
//                         <td className="text-right">{ov.weekly}</td>
//                       </tr>
//                       <tr>
//                         <td>Monthly</td>
//                         <td className="text-right">{ov.monthly}</td>
//                       </tr>
//                       <tr>
//                         <td>Yearly</td>
//                         <td className="text-right">{ov.yearly}</td>
//                       </tr>
//                       <tr>
//                         <td>Total</td>
//                         <td className="text-right bold">{ov.total}</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               ))}
//             </div>
//           </section>

//           <section className="section-card boxed-section mt-18">
//             <div className="charts-wrapper">
//               <div className="chart-block">
//                 <div className="chart-title">Monthly Collections (Line)</div>
//                 <div style={{ width: "100%", height: 260 }}>
//                   <ResponsiveContainer>
//                     <LineChart
//                       data={lineData}
//                       margin={{ top: 8, right: 20, left: 0, bottom: 8 }}
//                     >
//                       <CartesianGrid stroke="#e6eef6" strokeDasharray="3 3" />
//                       <XAxis dataKey="name" />
//                       <YAxis />
//                       <Tooltip />
//                       <Legend />
//                       <Line
//                         type="monotone"
//                         dataKey="collection"
//                         stroke="#2563eb"
//                         strokeWidth={2}
//                       />
//                       <Line
//                         type="monotone"
//                         dataKey="pending"
//                         stroke="#93c5fd"
//                         strokeWidth={2}
//                       />
//                     </LineChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               <div className="chart-block">
//                 <div className="chart-title">Loan Mix (Pie)</div>
//                 <div style={{ width: "100%", height: 260 }}>
//                   <ResponsiveContainer>
//                     <PieChart>
//                       <Pie
//                         data={pieData}
//                         dataKey="value"
//                         nameKey="name"
//                         outerRadius={80}
//                         innerRadius={40}
//                         paddingAngle={4}
//                       >
//                         {pieData.map((entry, index) => (
//                           <Cell
//                             key={`cell-${index}`}
//                             fill={pieColors[index % pieColors.length]}
//                           />
//                         ))}
//                       </Pie>
//                       <Tooltip />
//                       <Legend layout="horizontal" verticalAlign="bottom" />
//                     </PieChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>
//             </div>
//           </section>
//         </main>
//       </div>
//     </div>
//   );
// }



/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";

import { fetchPermissions } from "../redux/slices/branch/permissionManagerSlice";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

import "../assets/css/dashboard.css";

import {
  FaUserFriends,
  FaMoneyCheckAlt,
  FaSearch,
  FaClipboardList,
  FaFileInvoice,
  FaPlus,
} from "react-icons/fa";

export default function BranchDashboard() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const storedUserId = localStorage.getItem("userId");
  const userId = storedUserId ? Number(storedUserId) : null;

  const [collectionData, setCollectionData] = useState({});
  const [pendingCollectionData, setPendingCollectionData] = useState({});
  const [disbursementData, setDisbursementData] = useState({});
  const [company,setCompany]=useState(null)
  const [loading, setLoading] = useState(true);
  const [totalDashboardData,setTotalDashboardData] = useState({});

  const formatINR = (value = 0) =>
    `₹ ${Number(value || 0).toLocaleString("en-IN")}`;

  /* ---------------- LOAD PROFILE & PERMISSIONS ---------------- */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (userId) dispatch(fetchPermissions(userId));
  }, [dispatch, userId]);

  // Fetch Company
  useEffect(()=>{
    const fetchCompany=async()=>{
      try {
        const res = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
          );
          const data = await res.json();
          if (res.ok) {
            if (data.logo)
              data.logoUrl = `https://payyug.in/${data.logo.replace(
                /^images\//,
                ""
              )}`;
              // console.log("company",data)
            setCompany(data);
          }
      } catch (error) {
        console.log("Company fetching error:",error)
      }
    }

    fetchCompany()
  },[profile])

  /* ---------------- COLLECTION ---------------- */
  const fetchCollection = async () => {
    const res = await axios.get(
      "https://payyug.in/api/dashboard-collection/api",
      {
        params: {
          superAdminId: profile.superAdminId,
          branchId: profile.id,
        },
      },
    );
    // console.log("collection",res.data)
    setCollectionData(res.data?.data || {});
  };

  /* ---------------- PENDING COLLECTION ---------------- */
  const fetchPendingCollection = async () => {
    const res = await axios.get("https://payyug.in/api/dashboard-list/", {
      params: {
        superAdminId: profile.superAdminId,
        branchId: profile.id,
      },
    });
    // console.log("pending collection",res.data)
    setPendingCollectionData(res.data?.data || {});
  };

  /* ---------------- DISBURSEMENT (FIXED LOGIC) ---------------- */
  const fetchDisbursement = async () => {
    const filters = ["today", "week", "month", "year"];

    let disbursedTemp = {};
    let pendingTemp = {};

    let disbursedTotal = 0;
    let pendingTotal = 0;

    for (let f of filters) {
      const res = await axios.get(
        "https://payyug.in/api/dashbaord/loan-summery/disbursment",
        {
          params: {
            superAdminId: profile.superAdminId,
            filter: f,
          },
        },
      );

      // console.log("disbursement",res.data)
      const disbursedAmount = res.data?.data?.disbursed?.amount || 0;

      const pendingAmount = res.data?.data?.pendingDisbursement?.amount || 0;

      disbursedTemp[f] = disbursedAmount;
      pendingTemp[f] = pendingAmount;

      disbursedTotal += disbursedAmount;
      pendingTotal += pendingAmount;
    }

    setDisbursementData({
      disbursed: {
        today: disbursedTemp.today,
        weekly: disbursedTemp.week,
        monthly: disbursedTemp.month,
        yearly: disbursedTemp.year,
        total: disbursedTotal,
      },
      pending: {
        today: pendingTemp.today,
        weekly: pendingTemp.week,
        monthly: pendingTemp.month,
        yearly: pendingTemp.year,
        total: pendingTotal,
      },
    });
  };

  const fetchDashboardTotal = async () => {
    if(!profile?.superAdminId)
       return ; 
    try{
       const res= await axios.get(`https://payyug.in/api/all-dashboard/customer/branch?branchId=${profile.id}`);
       if(res)
       {
        // console.log(res);
        setTotalDashboardData(res.data);
       }
     }
    catch(error){
        console.log(error);
    }
  }

  /* ---------------- LOAD DASHBOARD ---------------- */
  useEffect(() => {
    if (!profile?.superAdminId || !profile?.id) return;

    setLoading(true);
    Promise.all([
      fetchCollection(),
      fetchPendingCollection(),
      fetchDisbursement(),
      fetchDashboardTotal(),
    ]).finally(() => setLoading(false));
  }, [profile]);


  if (loading) return <p className="loading-text">Loading dashboard...</p>;
  // console.log("total loans are", totalDashboardData.data.loans.others)
  /* ---------------- UI DATA ---------------- */
  // const kpiData = [
  //   {
  //     label: "Total Customers",
  //     value: totalDashboardData.data.totalCustomers,
  //     color: "#2aa9b8",
  //     icon: <FaUserFriends />,
  //   },
  //   {
  //     label: "Total Active Loans",
  //     value: `${totalDashboardData.data.totalLoans}`,
  //     color: "#d9c39a",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //   {
  //     label: "Today Due Emi",
  //     value: `${totalDashboardData.data.loans.active}`,
  //     color: "#d9c39a",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //   {
  //     label: "Today Collection",
  //     value: "₹ 0",
  //     color: "#d9c39a",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //   {
  //     label: "Total Saving Account",
  //     value: `${totalDashboardData.data.totalSavingAccounts}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //   {
  //     label: "Total FD Account",
  //     value: `${totalDashboardData.data.fdMisAccounts.fd}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //    {
  //     label: "Total MIS Account",
  //     value: `${totalDashboardData.data.fdMisAccounts.mis}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //    {
  //     label: "Total RD Account",
  //     value: `${totalDashboardData.data.depositAccounts.rd}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //    {
  //     label: "Total DD Account",
  //     value: `${totalDashboardData.data.depositAccounts.dd}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
     

  // ];


  const kpiData = [
    {
      label: "Total Customers",
      value: totalDashboardData?.data?.totalCustomers ?? 0,
      color: "#2aa9b8",
      icon: <FaUserFriends />,
    },
    {
      label: "Total Active Loans",
      value: totalDashboardData?.data?.loans?.active ?? 0,
      color: "#d9c39a",
      icon: <FaMoneyCheckAlt />,
    },
    // {
    //   label: "Today Due Emi",
    //   // value: totalDashboardData?.data?.loans?.active ?? 0,
    //   value: 0,
    //   color: "#d9c39a",
    //   icon: <FaMoneyCheckAlt />,
    // },
    // {
    //   label: "Today Collection",
    //   value: totalDashboardData?.data?.todayCollection ?? "₹ 0",
    //   color: "#d9c39a",
    //   icon: <FaMoneyCheckAlt />,
    // },

    // hiding in aayogfin at building time
    {
      label: "Total Saving Account",
      value: totalDashboardData?.data?.totalSavingAccounts ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total FD Account",
      value: totalDashboardData?.data?.fdMisAccounts?.fd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total MIS Account",
      value: totalDashboardData?.data?.fdMisAccounts?.mis ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total RD Account",
      value: totalDashboardData?.data?.depositAccounts?.rd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total DD(Pigmy) Account",
      value: totalDashboardData?.data?.depositAccounts?.dd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
  ];

  const quickAccess = [
    {
      label: "Create Customer",
      icon: <FaPlus />,
      link: "/Customers/add",
    },
    {
      label: "Search Customer",
      icon: <FaSearch />,
      link: "/Customers/SearchCustomer",
    },
    {
      label: "Customer Reports",
      icon: <FaFileInvoice />,
      link: "/CustomerReport",
    },
    {
      label: "Loan Apply",
      icon: <FaClipboardList />,
      link: "/Loan/PersonalLoanForm",
    },

    {
      label: "Loan Reports",
      icon: <FaFileInvoice />,
      link: "/Loan/LoanReport",
    },
  ];

  const overviewData = [
    {
      title: "Collection",
      today: formatINR(collectionData.today),
      weekly: formatINR(collectionData.weekly),
      monthly: formatINR(collectionData.monthly),
      yearly: formatINR(collectionData.yearly),
      total: formatINR(collectionData.total),
    },
    {
      title: "Pending Collection",
      today: formatINR(pendingCollectionData.today),
      weekly: formatINR(pendingCollectionData.weekly),
      monthly: formatINR(pendingCollectionData.monthly),
      yearly: formatINR(pendingCollectionData.yearly),
      total: formatINR(pendingCollectionData.total),
    },
    {
      title: "Disbursement",
      today: formatINR(disbursementData?.disbursed?.today),
      weekly: formatINR(disbursementData?.disbursed?.weekly),
      monthly: formatINR(disbursementData?.disbursed?.monthly),
      yearly: formatINR(disbursementData?.disbursed?.yearly),
      total: formatINR(disbursementData?.disbursed?.total),
    },
    {
      title: "Pending Disbursement",
      today: formatINR(disbursementData?.pending?.today),
      weekly: formatINR(disbursementData?.pending?.weekly),
      monthly: formatINR(disbursementData?.pending?.monthly),
      yearly: formatINR(disbursementData?.pending?.yearly),
      total: formatINR(disbursementData?.pending?.total),
    },
    {
      title: "Created Loan",
      today: "₹ 0",
      weekly: "₹ 0",
      monthly: "₹ 0",
      yearly: "₹ 0",
      total: "₹ 0",
    },
    {
      title: "Opened Account",
      today: "₹ 0",
      weekly: "₹ 0",
      monthly: "₹ 0",
      yearly: "₹ 0",
      total: "₹ 0",
    },
  ];

  /* ---------------- JSX ---------------- */
  return (
    <div className="bd-dashboard-root">
      <div className="bd-dashboard-header">
        <div className="running-text ">
          <h1 
          className="gradient-text-white"
          >Welcome, {company?.name||"Company Name"}, Branch({profile.branchName})</h1>
        </div>
      </div>

        <div className="db-kpis-quick-grid">
        {/* KPIs */}
        <div className="bd-kpi-card">
          {/* <h2 className="bd-card-title">KPIs</h2> */}

          <div className="bd-kpi-list">
            {kpiData.map((kpi, index) => (
              <div className={`bd-kpi-row `} key={index}>
                <div className={`bd-kpi-icon bd-kpi-${index + 1}`}>{kpi.icon}</div>

                <div className="bd-kpi-text">
                  <span className="bd-kpi-value">{kpi.value}</span>
                  <span className="bd-kpi-label">{kpi.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* QUICK ACCESS */}
        <div className="bd-quick-card">
          <h2 className="bd-card-title">Quick Access</h2>

          <div className="bd-quick-grid">
            {quickAccess.map((item, index) => (
              <Link
                to={item.link}
                key={index}
                className={`bd-quick-item bd-quick-${index + 1}`}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </div>
        </div>

      {/* COLLECTION OVERVIEW */}
<section className="bd-collection-section">
  <div className="bd-overview-grid">
    {overviewData.map((ov, index) => (
      <div className={`bd-overview-card color-${index}`} key={index}>
        <div className="bd-overview-header">
           <h3 className="bd-overview-title">{ov.title}</h3>
           {/* <p className="bd-overview-subtitle">{ov.subtitle || "AMOUNT"}</p> */}
        </div>

        <div className="bd-overview-stats">
          <div className="bd-stat-row">
            <span>TODAY</span>
            <span className="bd-stat-value">{ov.today}</span>
          </div>
          <div className="bd-stat-row">
            <span>WEEKLY</span>
            <span className="bd-stat-value">{ov.weekly}</span>
          </div>
          <div className="bd-stat-row">
            <span>MONTHLY</span>
            <span className="bd-stat-value">{ov.monthly}</span>
          </div>
          <div className="bd-stat-row">
            <span>YEARLY</span>
            <span className="bd-stat-value">{ov.yearly}</span>
          </div>
          <div className="bd-stat-row bd-stat-total">
            <span>TOTAL</span>
            <span className="bd-stat-value">{ov.total}</span>
          </div>
        </div>
      </div>
    ))}
  </div>
</section>
    </div>
  );
}
